interface MassParticipantTableProps {
  headers: string[];
  data: {[x:string]:any}[];
}

export const MassParticipantTable = ({headers = [], data = []}: MassParticipantTableProps) => {
  
  return (
    <div className="flow-root">
      <div className="relative overflow-x-auto min-w-full">
        <table className="table-auto w-max divide-y divide-gray-300 bg-magnolia-500 rounded-md min-w-full">
          <thead>
            <tr>
              {headers.map((header, index) => (
                <th
                  key={index}
                  className="th"
                >
                  {header}
                </th>
              ))}
            </tr>
          </thead>

          <tbody className="divide-y divide-gray-200 bg-white">
            {data.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {headers.map((header, colIndex) => (
                  <td
                    key={colIndex}
                    className="td"
                  >
                    {row[header]}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
  </div>
  )
}